export const convertBalanceToNum = (val) => {
  if (typeof val === 'number') return val;

  const normalized = val
    .toString()
    .replace(/\s/g, '')     // убираем пробелы
    .replace(/\./g, '')     // убираем разделители тысяч
    .replace(',', '.');     // заменяем десятичный разделитель

  const result = Number(normalized);

  return Number.isNaN(result) ? 0 : result;
};